var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.65918H513V342.626H0V0.65918Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 38.6328L266.62 69.8937H299.584L272.932 89.2314L283.152 120.492L256.5 101.155L229.848 120.492L240.068 89.2314L213.416 69.8937H246.38L256.5 38.6328ZM123.441 171.692L154.702 161.472V128.608L174.039 155.26L205.3 145.04L185.963 171.692L205.3 198.244L174.039 188.124L154.702 214.676V181.812L123.441 171.692ZM256.5 304.752L246.38 273.491H213.416L240.068 254.153L229.848 222.792L256.5 242.13L283.152 222.792L272.932 254.153L299.584 273.491H266.62L256.5 304.752ZM389.559 171.692L358.298 181.812V214.676L338.961 188.124L307.7 198.244L327.038 171.692L307.7 145.04L338.961 155.26L358.298 128.608V161.472L389.559 171.692Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 0.65918)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFm);
export default __webpack_public_path__ + "static/media/FM.140aa2df49b41b835ea97ae0a0831617.svg";
export { ForwardRef as ReactComponent };